import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faObjectGroup } from '@fortawesome/free-solid-svg-icons';
import { LinearProgress } from '@mui/material';
import { withRouter } from 'react-router-dom';
import CommonContext from '../Common';
import { ApiRoutes } from '../ApiRoutes';
import { PageHeading, PageWrap } from '../common/forms/FormElements';
import { util } from '../Util';
import { Button, Table } from 'reactstrap';
import { EquipmentGroupForm } from './EquipmentGroupForm';

class EquipmentGroupIndex extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);

        this.eqGroupForm = React.createRef();

        this.state = {
            loading: true,
            equipmentGroups: [],
            equipmentTypes: [],
            selectedEquipmentGroup: null,
            showEquipmentGroupForm: false,
        };

        this.onEditEquipmentGroup = this.onEditEquipmentGroup.bind(this);
        this.onEquipmentGroupFormClosed =
            this.onEquipmentGroupFormClosed.bind(this);
    }

    componentDidMount() {
        return this.populateState();
    }

    onEditEquipmentGroup = (id) => {
        if (!this.eqGroupForm || !this.eqGroupForm.current) {
            return;
        }

        this.eqGroupForm.current.open(id);
    };

    onEquipmentGroupFormClosed() {
        this.setState({ showEquipmentGroupForm: false });
        this.populateState();
    }

    onEquipmentGroupSaveCallback = () => {
        this.setState({ showEquipmentGroupForm: false });
        this.context.setFormOpened(false);

        this.populateState();
    };

    async populateState() {
        this.setState({ loading: true });

        const [equipmentGroups, equipmentTypes] = await Promise.all([
            util.fetch.js(ApiRoutes.equipmentGroup.all()),
            util.fetch.js(ApiRoutes.equipmentType.all()),
        ]);

        this.setState({
            loading: false,
            equipmentGroups,
            equipmentTypes,
        });
    }

    getEquipmentTypeNames = (equipmentGroup) => {
        if (!equipmentGroup || !equipmentGroup.equipmentTypeIds) {
            return 'None';
        }

        const { equipmentTypes } = this.state;

        const representedEquipmentTypes = equipmentTypes.filter((et) =>
            equipmentGroup.equipmentTypeIds.includes(et.id)
        );

        if (!representedEquipmentTypes.length) {
            return 'None';
        }

        return representedEquipmentTypes.map((et) => et.description).join(', ');
    };

    render() {
        const {
            loading,
            equipmentGroups,
            equipmentTypes,
            showEquipmentGroupForm,
        } = this.state;

        if (loading) {
            return <LinearProgress variant="indeterminate" color="secondary" />;
        }

        return (
            <PageWrap>
                <PageHeading>
                    <FontAwesomeIcon
                        icon={faObjectGroup}
                        className="mr-2 text-muted"
                    />
                    <span>Equipment Groups</span>
                </PageHeading>
                <Table>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Represented Equipment Types</th>
                        </tr>
                    </thead>
                    <tbody>
                        {equipmentGroups.map((eg) => (
                            <tr key={eg.id}>
                                <td>
                                    <Button
                                        color="success"
                                        onClick={() =>
                                            this.onEditEquipmentGroup(eg.id)
                                        }
                                    >
                                        {eg.name}
                                    </Button>
                                </td>
                                <td>{this.getEquipmentTypeNames(eg)}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
                <EquipmentGroupForm
                    ref={this.eqGroupForm}
                    onClose={this.onEquipmentGroupFormClosed}
                    show={showEquipmentGroupForm}
                    onSaveCallback={this.onEquipmentGroupSaveCallback}
                    equipmentTypes={equipmentTypes}
                />
            </PageWrap>
        );
    }
}
export default withRouter(EquipmentGroupIndex);
